import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import MenuItem from "./MenuItem";
const StyledMenuItem = styled(MenuItem)(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
  `
);
const DeleteMenuItem = ({ children = void 0, ...props }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledMenuItem, { ...props }, children != null ? children : t("actions.delete"));
};
export default DeleteMenuItem;
